// LawyerFAQSection.tsx

import { useEffect, useState } from 'react';
import axios from 'axios';
import { newServer } from '../../../src/constants/constants';
import { useTranslation } from 'react-i18next';
const endpoint = `${newServer}lawyer-types/get-all-lawyer-types`;
const FONT_STYLE = { fontFamily: 'Poppins, sans-serif' };

const LawyerFAQSection = () => {
  const { t, i18n } = useTranslation();
  const [expandedLawyer, setExpandedLawyer] = useState<string | null>(null);
  const [lawyerTypes, setLawyerTypes] = useState<any[]>([]);
  const locale = i18n.language;
  useEffect(() => {
    const fetchLawyerTypes = async () => {
      try {
        const response = await axios.get(endpoint);
        setLawyerTypes(response.data as any[]);
      } catch (error) {
        console.error('Error fetching lawyer types:', error);
      }
    };

    fetchLawyerTypes();
  }, []);

  const toggleExpand = (searchParam: string) => {
    setExpandedLawyer((prev) => (prev === searchParam ? null : searchParam));
  };

  return (
    <div className='max-w-4xl mx-auto px-4 py-8'>
      <h2 className='text-4xl font-bold text-center text-black' style={FONT_STYLE}>
      {t('not_sure_what').toString()}{' '}
        {/* TODO: Configurable via i18n , Additional : Dynamic Variable for "LawyerFAQSection Super Admin Backoffice Theme Management*/}
      </h2>
      <p className='mt-2 text-center text-slate-700 font-semibold' style={FONT_STYLE}>
        {t('click_a_category').toString()}
        {/* TODO: Configurable via i18n , Additional : Dynamic Variable for "LawyerFAQSection Super Admin Backoffice Theme Management*/}
      </p>
      {lawyerTypes.map((lawyer) => (
        <div key={lawyer.id} className='p-4 border rounded-lg shadow-sm bg-white my-3'>
          {/* Lawyer Header */}
          <div className='flex justify-between items-center'>
            <h3 className='text-xl font-semibold'>
              <a
                href={`/directory/search?type=lawyer&search=${
                  lawyer.skill ? lawyer.skill : lawyer.title
                }`}
                rel='noopener noreferrer'
                className='text-foreground hover:underline capitalize'
              >
                {lawyer.title}
              </a>
            </h3>
            <button
              onClick={() => toggleExpand(lawyer.id)}
              className='text-lg font-bold text-black hover:text-blue-800 p-3 rounded-xl'
            >
              {expandedLawyer === lawyer.id ? '-' : '+'}
            </button>
          </div>
          {/* Expandable Section */}
          {expandedLawyer === lawyer.id && (
            <div className='mt-2 text-slate-700'>
              <p>
                <strong>Handles:</strong> {lawyer.handles}
              </p>
              <p>
                <strong>Example:</strong> {lawyer.example}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default LawyerFAQSection;
